<template>
<div>
    <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="直播名称">
            <el-input class="inputItem" v-model="form.ltName"></el-input>
        </el-form-item>
        <el-form-item label="主讲人">
            <el-input class="inputItem" v-model="form.speaker"></el-input>
        </el-form-item>
        <el-form-item label="直播类型">
            <el-select class="inputItem" v-model="form.ltType" placeholder="请选择直播类型" @change="ltTypeChange">
                <el-option label="直播" value="直播"></el-option>
                <el-option label="预告" value="预告"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="跳转链接">
            <el-input class="inputItem" v-model="form.ltUrl"></el-input>
        </el-form-item>
        <el-form-item label="直播时间">
            <el-date-picker class="inputItem" :disabled="timeState" v-model="form.ltTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="封面图">
            <el-upload list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" accept=".jpg,.jpeg,.png" :action="fileUploads.actionUrl" :headers="fileUploads.authToken" :before-upload="beforeUploadEvidenceMenu" :on-success="sendEvidenceMenu" :file-list="bannerfile">
                <i slot="default" class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :modal-append-to-body='false' title="封面预览" :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" round @click="onSubmit">提交</el-button>
            <el-button @click="canel" round>取消</el-button>
        </el-form-item>
    </el-form>
</div>
</template>

<script>
export default {
    props: {
        zbRowInfo: {
            type: Object
        }
    },
    data() {
        return {
            form: {
                ltid: '',
                speaker: '',
                ltName: '',
                ltType: '',
                ltUrl: '',
                ltTime: ''
            },
            tempLTTime: '',
            bannerfile: [],
            dialogImageUrl: '',
            dialogVisible: false,
            fileUploads: {
                actionUrl: process.env.VUE_APP_BASE_API + '/api/file/upload',
                authToken: {
                    JWTToken: sessionStorage.getItem('token'),
                    ctype: 'PC'
                }
            },
            editState: false,
            timeState: false
        }
    },
    methods: {
        beforeUploadEvidenceMenu(file) {
            console.log(file)
            if (['image/png', 'image/jpg', 'image/jpeg'].every(item => item != file.type)) {
                this.$message.error('仅支持png、jpg、jpeg格式的文件!');
                return false
            }
            const isLt = file.size / 1024 / 1024 < 10;
            if (!isLt) {
                this.$message.error('上传图片不能超过10M');
                return false
            }
            if (this.bannerfile.length == 1) {
                this.$message.error('一节课程只允许上传一个课程封面');
                return false
            }
        },
        sendEvidenceMenu(response, file, fileList) {
            console.log('----上传文件----', response, file)
            if (this.bannerfile.length > 1) {
                this.$message.error('一节课程只允许上传一个课程封面');
                return false
            }
            this.bannerfile.push({
                url: response.data,
                name: file.name
            })
        },
        onSubmit() {
            console.log(this.form)
            if (this.form.ltName.toString().trim() == "") {
                this.$message.warning('请输入直播名称')
                return
            }
            if (this.form.speaker.toString().trim() == "") {
                this.$message.warning('请输入主讲人')
                return
            }
            if (this.form.ltType.toString().trim() == "") {
                this.$message.warning('请输入直播类型')
                return
            }
            if (this.form.ltUrl.toString().trim() == "") {
                this.$message.warning('请输入直播跳转地址')
                return
            }
            if (this.form.ltType == "预告") {
                if (this.form.ltTime.toString().trim() == "") {
                    this.$message.warning('请输入直播时间')
                    return
                }
            }
            if (this.bannerfile.length == 0) {
                this.$message.warning('请上传直播封面图片')
                return
            }
            let that = this
            let params = {
                ltName: this.form.ltName,
                speaker: this.form.speaker,
                ltType: this.form.ltType,
                ltUrl: this.form.ltUrl,
                ltTime: this.timeState ? '' : this.form.ltTime,
                coverUrl: this.bannerfile.length > 0 ? this.bannerfile[0].url : this.form.coverUrl
            }
            if (this.form.ltid) {
                params.ltId = this.form.ltid
                this.$api.updateZBList(params).then(res => {
                    console.log(res)
                    if (res.status == "OK") {
                        this.$message.success('保存成功')
                        this.$emit('closeDialog')
                    } else {
                        this.$message.error('保存失败')
                    }
                })
            } else {
                this.$api.addZBList(params).then(res => {
                    console.log(res)
                    if (res.status == "OK") {
                        this.$message.success('保存成功')
                        this.$emit('closeDialog')
                    } else {
                        this.$message.error('保存失败')
                    }
                })
            }
        },
        handleRemove(file) {
            console.log(file);
            this.bannerfile = []
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        initZBData() {
            if (this.zbRowInfo.hasOwnProperty('ltId')) {
                this.form.ltid = this.zbRowInfo.ltId
                this.form.ltName = this.zbRowInfo.ltName
                this.form.speaker = this.zbRowInfo.speaker
                this.form.ltType = this.zbRowInfo.ltType
                this.form.ltUrl = this.zbRowInfo.ltUrl
                this.form.ltTime = this.zbRowInfo.ltTime
                this.bannerfile.push({
                    url: this.zbRowInfo.coverUrl,
                    name: '封面图'
                })
                if (this.zbRowInfo.ltType == '直播') {
                    this.timeState = true
                } else {
                    this.timeState = false
                }
            } else {
                this.form.ltid = ''
                this.form.ltName = ''
                this.form.speaker = ''
                this.form.ltType = ''
                this.form.ltUrl = ''
                this.form.ltTime = ''
                this.bannerfile = []
            }
        },
        canel() {
            this.$emit('closeDialog')
        },
        ltTypeChange(e) {
            console.log(e)
            if (e == '直播') {
                this.timeState = true
                if (this.form.ltTime) {
                    this.tempLTTime = JSON.stringify(this.form.ltTime)
                }
                this.form.ltTime = ''
            } else {
                this.timeState = false
                if (this.tempLTTime) {
                    this.form.ltTime = JSON.stringify(this.tempLTTime)
                }
            }
        }
    }
}
</script>

<style>
.inputItem {
    width: 360px !important;
}
</style>
